import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import InstructionManagement from "./components/InstructionManagement";
import AuditLog from "./components/AuditLog";
import GeminiConfiguration from "./components/GeminiConfiguration";

function App() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route
          path="/login"
          element={
            !isAuthenticated ? <Login /> : <Navigate to="/dashboard" replace />
          }
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/instructions"
          element={
            isAuthenticated ? (
              <InstructionManagement />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/audit"
          element={
            isAuthenticated ? <AuditLog /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/gemini"
          element={
            isAuthenticated ? (
              <GeminiConfiguration />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/"
          element={
            <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
          }
        />
      </Routes>
    </div>
  );
}

export default App;
